import Icon from '../components/Icon.vue'

Icon.register({
  'truck-moving': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M621.3 237.3c12 12 18.7 28.2 18.7 45.2v85.5c0 8.8-7.2 16-16 16h-17.6c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 0.5-10.8 1.6-16h-163.2c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80-26.3 0-49.4-12.8-64-32.4-14.6 19.5-37.7 32.4-64 32.4-44.2 0-80-35.8-80-80v-336c0-17.7 14.3-32 32-32h416c17.7 0 32 14.3 32 32v96.1h37.5c17 0 33.3 6.7 45.3 18.7zM80 432c17.6 0 32-14.4 32-32s-14.4-32-32-32-32 14.4-32 32 14.4 32 32 32zM208 432c17.6 0 32-14.4 32-32s-14.4-32-32-32-32 14.4-32 32 14.4 32 32 32zM480 208v48h92.1l-43.3-43.3c-3-3-7-4.7-11.3-4.7h-37.5zM528 432c17.6 0 32-14.4 32-32s-14.4-32-32-32-32 14.4-32 32 14.4 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/truck-moving.js
// module id = 2039
// module chunks = 0